<template>
  <ModalClose :modal="modal" asChild :disabled="disabled">
    <Button
      variant="primary"
      size="full"
      padding="none"
      class="py-4 px-6 md:py-2.5 md:px-4"
      :disabled="disabled"
    >
      {{ t("components.buttons.apply") }}
    </Button>
  </ModalClose>
</template>

<script setup>
import { Button } from "@/Components/Button";
import { ModalClose } from "@/Components/Buttons";
import { useI18n } from "vue-i18n";

defineProps({
  modal: { type: String, required: false },
  disabled: { type: Boolean, default: false },
});

const { t } = useI18n();
</script>
